module.exports = __webpack_public_path__ + "img/external-link-icon.f0e2f70e.svg";